import React from 'react';
import { promoBanner } from '../../data/homepage';
import { DecorPanel } from '../ui/DecorPanel';
import { PillButton } from '../ui/PillButton';

/**
 * Le bandeau que Beaconsfield affiche déjà sur son site. On n'invente rien : leur propre
 * promesse pointe désormais vers Mon espace.
 */
export function AppPromoBanner() {
  return <section aria-label="Portail citoyen" className="mx-auto w-full max-w-[1400px] px-5 pb-16 pt-5 lg:px-10" data-id="element-1735" data-mp="2he22d47qv7jb">
      <DecorPanel tone="navy" curve={{
      variant: 'wave',
      placement: 'top-left',
      className: 'h-full w-2/5'
    }} className="flex flex-wrap items-center justify-between gap-6 p-8 lg:px-12 lg:py-10" data-id="element-1736" data-mp="2cgs6p6trhzn1">
        <h2 className="max-w-md font-display text-2xl font-extrabold uppercase leading-[1.05] tracking-tight text-white lg:text-3xl" data-id="element-1737" data-mp="1yfpgchvqi36b">
          {promoBanner.title}
        </h2>
        <PillButton to={promoBanner.cta.to} variant="orange" data-id="element-1738" data-mp="p4wdjc03omd">
          {promoBanner.cta.label}
        </PillButton>
      </DecorPanel>
    </section>;
}